import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server, { uploadServer } from "../../api/server";
import axios from "axios";
import { v4 } from "uuid";

const AboutUsCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [currentInfo, setCurrentInfo] = useState({});
	const dispatch = useDispatch();
	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		getValues,
		reset,
		control,
	} = useForm();
	const { append, remove, fields } = useFieldArray({
		name: "extraInfo",
		control,
	});
	const [pictureImg, setPictureImg] = useState(userPlaceholder);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة فئة جديدة",
				breadcrumb: "الفئات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	// handleMethods
	const submitHandler = async data => {
		setLoading(true);
		try {
			const dataForm = new FormData();
			dataForm.append("file", data.pictureUrl[0]);

			const imageResponse = await uploadServer(cookie).post(
				"/upload",
				dataForm
			);

			const { picturePath, pictureUrl, ...finalData } = {
				...data,
				title: "about us",
				image: imageResponse.data.data.file.path,
			};
			const dataResponse = await server(cookie).post(
				"/pages/about-us/sections",
				{
					section: finalData,
				}
			);
			reset();
			setPictureImg(userPlaceholder);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	const handlePicture = () => {
		const tempValue = getValues("pictureUrl");
		if (tempValue.length < 1) return;
		const blobUrl = URL?.createObjectURL(tempValue?.[0]);
		setValue("picturePath", blobUrl);
		setPictureImg(blobUrl);
	};

	// watchers
	useEffect(() => {
		onStart();
	}, []);

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(submitHandler)}>
				<div className="row">
					<div className="col-md-8">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleAr">الروئية باللغة العربية</label>
									<input
										type="text"
										name="titleAr"
										id="titleAr"
										{...register("vision.title.ar", {
											required: true,
										})}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="titleEn">الروئية بالغة الانجليزية</label>
									<input
										type="text"
										name="titleEn"
										id="titleEn"
										{...register("vision.title.en", {
											required: true,
										})}
									/>
								</div>
							</div>

							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionAr">
										وصف الروئية باللغة العربية
									</label>
									<textarea
										name="descriptionAr"
										id="descriptionAr"
										cols="30"
										rows="3"
										{...register("vision.description.ar", {
											required: true,
										})}
									></textarea>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionEn">
										وصف الروئية بالغة الانجليزية
									</label>
									<textarea
										name="descriptionEn"
										id="descriptionEn"
										cols="30"
										rows="3"
										{...register("vision.description.en", {
											required: true,
										})}
									></textarea>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="subTitleAr">الرسالة باللغة العربية</label>
									<input
										type="text"
										name="subTitleAr"
										id="subTitleAr"
										{...register("message.title.ar", {
											required: true,
										})}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="subTitleEn">الرسالة بالغة الانجليزية</label>
									<input
										type="text"
										name="subTitleEn"
										id="subTitleEn"
										{...register("message.title.en", {
											required: true,
										})}
									/>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionAr">
										وصف الرسالة باللغة العربية
									</label>
									<textarea
										name="descriptionAr"
										id="descriptionAr"
										cols="30"
										rows="3"
										{...register("message.description.ar", {
											required: true,
										})}
									></textarea>
								</div>
							</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="descriptionEn">
										وصف الرسالة بالغة الانجليزية
									</label>
									<textarea
										name="descriptionEn"
										id="descriptionEn"
										cols="30"
										rows="3"
										{...register("message.description.en", {
											required: true,
										})}
									></textarea>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="picture">البانر</label>
									<input
										type="file"
										id="picture"
										{...register("pictureUrl", {
											required: true,
											onChange: () => handlePicture(),
										})}
									/>
									<img src={pictureImg} alt="avatar" className="imagePreview" />
								</div>
							</div>
							<div className="card-body">
								<div className="row">
									<div className="col-md-12">
										<div className="form-item">
											<label htmlFor="infoTitle.ar">
												العنوان بالغة العربية
											</label>
											<input
												type="text"
												name="infoTitle.ar"
												id="infoTitle.ar"
												onChange={e =>
													setCurrentInfo({
														...currentInfo,
														name: { ...currentInfo.name, ar: e.target.value },
													})
												}
											/>
										</div>
										<div className="form-item">
											<label htmlFor="infoTitle.en">
												العنوان بالغة الانجليزية
											</label>
											<input
												type="text"
												name="infoTitle.en"
												id="infoTitle.en"
												onChange={e =>
													setCurrentInfo({
														...currentInfo,
														name: { ...currentInfo.name, en: e.target.value },
													})
												}
											/>
										</div>
										<div className="form-item">
											<label htmlFor="count">الكمية</label>
											<input
												type="number"
												name="count"
												id="count"
												min={0}
												onChange={e =>
													setCurrentInfo({
														...currentInfo,
														count: e.target.value,
													})
												}
											/>
										</div>
										<div className="form-item">
											<p
												className="bt bt-success btn-block"
												onClick={() =>
													fields.length > 1 ? null : append({ ...currentInfo })
												}
												style={{ textAlign: "center", cursor: "pointer" }}
											>
												اضف المعلومة
											</p>
										</div>
									</div>
									{fields.map((field, index) => (
										<div className="col-md-12" key={v4()}>
											انجاز {index + 1}
											<p>
												{field?.name.ar} <span>{field?.count}</span>
											</p>
											<i
												className="fas fa-trash"
												onClick={() => remove(index)}
											/>
										</div>
									))}
								</div>
							</div>
						</div>
						<input
							type="text"
							name=""
							id=""
							style={{ display: "none" }}
							{...register("picturePath")}
						/>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default AboutUsCreate;
